import React, { useState, useEffect } from "react";
import {
  Container,
  Row,
  Col,
  CardBody,
  Form,
  Input,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
} from "reactstrap";
import { Link } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import classnames from "classnames";
import PhoneAuth from "./PhoneAuth";

//Import Image
import lightLogo from "../../assets/images/logo-light.png";
import darkLogo from "../../assets/images/logo-dark.png";
import { signInWithCustomToken } from "firebase/auth";
import signInImage from "../../assets/images/auth/sign-in.png";

import axios from "axios";
import apiClient from "../../api/axiosInstance";
import { Route, Navigate, useNavigate } from "react-router-dom";
import "./style.css";
import { getToken } from "firebase/messaging";
import { messaging } from "./firebase-config";
import { onMessage } from "firebase/messaging";

import { getAuth, signInWithEmailAndPassword } from "firebase/auth";
import "./nav.css";
import googleLogin from "../../assets/images/google-login.png";
import { jwtDecode } from "jwt-decode";

const SignIn = () => {
  document.title = "Sign In | StarMarket";
  const navigate = useNavigate();

  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [activeTab, setActiveTab] = useState("1");
  const [phoneNumber, setPhoneNumber] = useState("");

  const toggleTab = (tab) => {
    if (activeTab !== tab) setActiveTab(tab);
  };
  const [isAuthenticated, setIsAuthenticated] = useState(null); // Null indicates loading state
  const accessToken = localStorage.getItem("accessToken");
  useEffect(() => {
    console.log(accessToken);
    const checkAuthStatus = async () => {
      if (!accessToken) {
        console.log("here");
        setIsAuthenticated(false);
        return;
      }

      try {
        const response = await apiClient.get("/is-token-expired");
        setIsAuthenticated(!response.data.expired); // If not expired, set as authenticated
        console.log("authenticated");
      } catch (error) {
        console.error("Error while checking token expiration:", error);
        setIsAuthenticated(false);
      }
    };

    checkAuthStatus();
  }, [accessToken]);

  async function loginUser(email, password) {
    const auth = getAuth();
    try {
      const userCredential = await signInWithEmailAndPassword(
        auth,
        email,
        password
      );
      const result = await userCredential.user.getIdToken(); // Get the ID token
      console.log(result);
      return result;
    } catch (error) {
      console.error("Error logging in:", error.message);
      throw error;
    }
  }

  const login = async () => {
    setError(null);

    try {
      const deviceId = await requestNotificationPermission();
      // Send phone number to backend
      const response = await fetch(
        "https://api.starmarketapi.online/login_firebase/login-with-phone",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ phoneNumber, token: deviceId }),
        }
      );

      const data = await response.json();
      if (!response.ok) {
        toast.error(data.error || "Login failed. Please try again.", {
          position: "top-right",
          autoClose: 3000,
        });
        throw new Error(data.error);
      }

      // Sign in with custom token
      const auth = getAuth();
      const userCredential = await signInWithCustomToken(auth, data.token);
      userCredential.user.getIdToken().then((idToken) => {
        console.log("ID Token:", idToken); // You can use this token for authentication
      });

      console.log("Logged in:", userCredential.user);
      const accessToken = userCredential.user.stsTokenManager.accessToken;
      const refreshToken = userCredential.user.stsTokenManager.refreshToken;

      // Save tokens to localStorage
      localStorage.setItem("accessToken", accessToken);
      localStorage.setItem("refreshToken", refreshToken);

      toast.success("Login successful!", {
        position: "top-right",
        autoClose: 2000,
      });

      try {
        const response = await axios.get(
          `https://api.starmarketapi.online/login_firebase/user-role/${userCredential.user.uid}`
        );
        const role = response.data.role;

        setTimeout(() => {
          switch (role) {
            case "processing_plant":
              navigate("/PlantDashboard");
              console.log("processing_plant");
              break;
            case "boat_owner":
              navigate("/BoatOwnerDashboard");
              console.log("boat_owner");
              break;
            case "courier":
              navigate("/CourierDashboard");
              console.log("courier");
              break;
            case "boat_inspector":
              navigate("/BoatInspectorDashboard");
              console.log("boat inspector");
              break;
            case "buyer":
              navigate("/");
              console.log("buyer");
              break;
          }
        }, 2000);
      } catch (err) {
        toast.error("Failed to fetch user role. Please try again.", {
          position: "top-right",
          autoClose: 3000,
        });
        console.log("Failed to fetch user role");
      }
    } catch (err) {
      setError(err.message);
      toast.error(err.message || "Login failed. Please try again.", {
        position: "top-right",
        autoClose: 3000,
      });
    }
  };

  const requestNotificationPermission = async () => {
    try {
      const permission = await Notification.requestPermission();

      if (permission === "granted") {
        console.log("Notification permission granted.");
        // Get FCM token (device ID)
        const token = await getToken(messaging, {
          vapidKey:
            "BBWp8NC-KxklYuyVfI8qI0CDfjEnFgHcsTK0QUD7qYjwMI5Q1hFFS5B5WFP1N1dvv9A-APZRhQog05Nrlo_tRhM",
        });
        if (token) {
          console.log("FCM Token:", token);
          // Send the token to the server to register the device
          return token;
        } else {
          toast.error("Failed to get notification token.", {
            position: "top-right",
            autoClose: 3000,
          });
          console.error("No FCM token found.");
        }
      } else {
        toast.warning(
          "Notification permission denied. You may not receive notifications.",
          {
            position: "top-right",
            autoClose: 3000,
          }
        );
        console.log("Notification permission denied.");
      }
    } catch (error) {
      toast.error("Error setting up notifications.", {
        position: "top-right",
        autoClose: 3000,
      });
      console.error("Error getting notification permission or token:", error);
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    const deviceId = await requestNotificationPermission();
    console.log(deviceId);
    try {
      // Send login request
      const idToken = await loginUser(username, password);

      const response = await axios.post(
        "https://api.starmarketapi.online/login_firebase/login",
        {
          idToken: idToken,
          token: deviceId,
        }
      );

      const decodedToken = jwtDecode(idToken);
      console.log(decodedToken);
      if (response.status == 200) {
        toast.success("Login successful!", {
          position: "top-right",
          autoClose: 2000,
        });

        try {
          const response = await axios.get(
            `https://api.starmarketapi.online/login_firebase/user-role/${decodedToken.user_id}`
          );
          const role = response.data.role;

          setTimeout(() => {
            switch (role) {
              case "processing_plant":
                navigate("/PlantOwnerDashboard");
                console.log("processing_plant");
                break;
              case "boat_owner":
                navigate("/BoatOwnerDashboard");
                console.log("boat_owner");
                break;
              case "courier":
                navigate("/CourierDashboard");
                console.log("courier");
                break;
              case "boat_inspector":
                navigate("/BoatInspectorDashboard");
                console.log("boat inspector");
                break;
              case "buyer":
                navigate("/");
                console.log("buyer");
                break;
            }
          }, 2000);
        } catch (err) {
          toast.error("Failed to fetch user role. Please try again.", {
            position: "top-right",
            autoClose: 3000,
          });
          console.log("Failed to fetch user role");
        }
      }

      // const { access_token, refresh_token } = response.data;

      // // Store tokens in localStorage or sessionStorage
      // localStorage.setItem("accessToken", access_token);
      // localStorage.setItem("refreshToken", refresh_token);
      //setToken(access_token, refresh_token);

      // Notify parent component that login was successful
      //onLogin(accessToken);
    } catch (err) {
      console.error("Login failed:", err);
      setError("Invalid credentials. Please try again.");
      toast.error("Invalid credentials. Please try again.", {
        position: "top-right",
        autoClose: 3000,
      });
    }
  };

  const setPhoneNumberOut = (phoneNumber1) => {
    setPhoneNumber(phoneNumber1);
  };

  return isAuthenticated ? (
    <Navigate
      to="/"
      replace
    />
  ) : (
    <React.Fragment>
      <ToastContainer />
      <div
        className="main-content"
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          minHeight: '100vh',
        }}
      >
        <div className="main-content">
          <div className="page-content">
            <section className="">
              <Container fluid>
                <Row className="justify-content-center">
                  <Col
                    xl={10}
                    lg={12}
                  >
                    <div
                      className="auth-box"
                      style={{ boxShadow: 'none !important' }}
                    >
                      <Row>
                        <Col lg={6}>
                          <div className="card-body1">
                            <h1
                              style={{
                                position: 'relative',
                                bottom: '10px',
                                left: '10px',
                                padding: '20px',
                              }}
                            >
                              From the sea to your home
                            </h1>
                          </div>
                        </Col>
                        <Col lg={6}>
                          <CardBody className="auth-content p-5 h-100 text-black">
                            <img
                              src={lightLogo}
                              alt="logo"
                              className="logo-light"
                              style={{
                                padding: '20px',
                                textAlign: 'left',
                                height: '80px',
                                display: 'inline-block',
                                marginRight: 'auto',
                                marginBottom: '10px',
                              }}
                            />
                            <div className="w-100">
                              <div className="mb-4">
                                <span
                                  style={{
                                    fontSize: '18px',
                                    fontWeight: '700',
                                    color: '#1a1a1a',
                                    marginBottom: '10px',
                                    display: 'block',
                                    textAlign: 'center',
                                  }}
                                >
                                  Welcome to StarMarket!
                                </span>
                                <p
                                  className="text-black body-small"
                                  style={{
                                    fontSize: '15px',
                                    color: '#6c757d',
                                    textAlign: 'center',
                                  }}
                                >
                                  Log in to your account to access all the
                                  latest updates
                                </p>
                              </div>

                              {/* Tabs Navigation (Placed Below the Description) */}
                              <Nav
                                tabs
                                className="mb-3"
                                style={{ borderBottom: 'none' }}
                              >
                                <NavItem style={{ flex: 1 }}>
                                  <NavLink
                                    className={classnames({
                                      active: activeTab === '1',
                                    })}
                                    onClick={() => toggleTab('1')}
                                    style={{
                                      cursor: 'pointer',
                                      padding: '12px 20px',
                                      borderRadius: '8px 0 0 8px',
                                      fontWeight: '600',
                                      fontSize: '15px',
                                      transition: 'all 0.3s ease',
                                      backgroundColor:
                                        activeTab === '1'
                                          ? '#007bff'
                                          : 'transparent',
                                      color:
                                        activeTab === '1' ? '#fff' : '#6c757d',
                                      border:
                                        activeTab === '1'
                                          ? '2px solid #007bff'
                                          : '2px solid #e9ecef',
                                      boxShadow:
                                        activeTab === '1'
                                          ? '0 4px 12px rgba(0, 123, 255, 0.3)'
                                          : 'none',
                                      textAlign: 'center',
                                    }}
                                    onMouseEnter={(e) => {
                                      if (activeTab !== '1') {
                                        e.currentTarget.style.backgroundColor =
                                          '#f8f9fa';
                                        e.currentTarget.style.color = '#495057';
                                      }
                                    }}
                                    onMouseLeave={(e) => {
                                      if (activeTab !== '1') {
                                        e.currentTarget.style.backgroundColor =
                                          'transparent';
                                        e.currentTarget.style.color = '#6c757d';
                                      }
                                    }}
                                  >
                                    📱 Phone
                                  </NavLink>
                                </NavItem>
                                <NavItem style={{ flex: 1 }}>
                                  <NavLink
                                    className={classnames({
                                      active: activeTab === '2',
                                    })}
                                    onClick={() => toggleTab('2')}
                                    style={{
                                      cursor: 'pointer',
                                      padding: '12px 20px',
                                      borderRadius: '0 8px 8px 0',
                                      fontWeight: '600',
                                      fontSize: '15px',
                                      transition: 'all 0.3s ease',
                                      backgroundColor:
                                        activeTab === '2'
                                          ? '#007bff'
                                          : 'transparent',
                                      color:
                                        activeTab === '2' ? '#fff' : '#6c757d',
                                      border:
                                        activeTab === '2'
                                          ? '2px solid #007bff'
                                          : '2px solid #e9ecef',
                                      boxShadow:
                                        activeTab === '2'
                                          ? '0 4px 12px rgba(0, 123, 255, 0.3)'
                                          : 'none',
                                      textAlign: 'center',
                                    }}
                                    onMouseEnter={(e) => {
                                      if (activeTab !== '2') {
                                        e.currentTarget.style.backgroundColor =
                                          '#f8f9fa';
                                        e.currentTarget.style.color = '#495057';
                                      }
                                    }}
                                    onMouseLeave={(e) => {
                                      if (activeTab !== '2') {
                                        e.currentTarget.style.backgroundColor =
                                          'transparent';
                                        e.currentTarget.style.color = '#6c757d';
                                      }
                                    }}
                                  >
                                    📧 Email
                                  </NavLink>
                                </NavItem>
                              </Nav>

                              {/* Tab Content */}
                              <TabContent activeTab={activeTab}>
                                {/* Phone Authentication */}
                                <TabPane tabId="1">
                                  <PhoneAuth
                                    setPhoneNumberOut={setPhoneNumberOut}
                                    login={login}
                                  />
                                  <div className="mt-4 text-center">
                                    <p className="mb-0">
                                      Don't have an account ?{' '}
                                      <Link
                                        to="/signup"
                                        className="fw-medium text-decoration-underline"
                                      >
                                        {' '}
                                        Register{' '}
                                      </Link>
                                    </p>
                                  </div>
                                </TabPane>

                                {/* Email Authentication */}
                                <TabPane tabId="2">
                                  <Form className="auth-form">
                                    <div className="mb-3">
                                      <Input
                                        type="text"
                                        className="form-control"
                                        id="usernameInput"
                                        value={username}
                                        onChange={(e) =>
                                          setUsername(e.target.value)
                                        }
                                        placeholder="📧 Email Address"
                                        required
                                        style={{
                                          background: '#f8f9fc',
                                          color: 'grey',
                                          border: '2px solid #e9ecef',
                                          borderRadius: '8px',
                                          padding: '12px 16px',
                                          fontSize: '14px',
                                          transition: 'all 0.3s ease',
                                        }}
                                        onFocus={(e) => {
                                          e.target.style.borderColor =
                                            '#007bff';
                                          e.target.style.boxShadow =
                                            '0 0 0 3px rgba(0, 123, 255, 0.1)';
                                        }}
                                        onBlur={(e) => {
                                          e.target.style.borderColor =
                                            '#e9ecef';
                                          e.target.style.boxShadow = 'none';
                                        }}
                                      />
                                    </div>
                                    <div className="mb-3">
                                      <Input
                                        type="password"
                                        className="form-control"
                                        id="passwordInput"
                                        value={password}
                                        onChange={(e) =>
                                          setPassword(e.target.value)
                                        }
                                        placeholder="🔒 Password"
                                        style={{
                                          background: '#f8f9fc',
                                          color: 'grey',
                                          border: '2px solid #e9ecef',
                                          borderRadius: '8px',
                                          padding: '12px 16px',
                                          fontSize: '14px',
                                          transition: 'all 0.3s ease',
                                        }}
                                        onFocus={(e) => {
                                          e.target.style.borderColor =
                                            '#007bff';
                                          e.target.style.boxShadow =
                                            '0 0 0 3px rgba(0, 123, 255, 0.1)';
                                        }}
                                        onBlur={(e) => {
                                          e.target.style.borderColor =
                                            '#e9ecef';
                                          e.target.style.boxShadow = 'none';
                                        }}
                                        required
                                      />
                                    </div>
                                    <p
                                      className="text-black body-small"
                                      style={{
                                        fontWeight: 500,
                                        fontSize: '13px',
                                        color: '#6c757d',
                                      }}
                                    >
                                      🤔 Having trouble signing in?
                                    </p>

                                    <div className="text-center mb-2">
                                      <button
                                        type="submit"
                                        onClick={handleSubmit}
                                        className="btn-blue btn-hover w-100"
                                        style={{
                                          fontSize: '16px',
                                          fontWeight: '600',
                                          padding: '14px',
                                          borderRadius: '8px',
                                          boxShadow:
                                            '0 4px 12px rgba(0, 123, 255, 0.3)',
                                          transition: 'all 0.3s ease',
                                        }}
                                        onMouseEnter={(e) => {
                                          e.target.style.transform =
                                            'translateY(-2px)';
                                          e.target.style.boxShadow =
                                            '0 6px 16px rgba(0, 123, 255, 0.4)';
                                        }}
                                        onMouseLeave={(e) => {
                                          e.target.style.transform =
                                            'translateY(0)';
                                          e.target.style.boxShadow =
                                            '0 4px 12px rgba(0, 123, 255, 0.3)';
                                        }}
                                      >
                                        🚀 Sign In
                                      </button>
                                    </div>
                                  </Form>

                                  <p
                                    className="text-black text-center body-small mb-2"
                                    style={{
                                      fontSize: '13px',
                                      color: '#6c757d',
                                    }}
                                  >
                                    ✨ or sign in with ✨
                                  </p>

                                  <div className="text-center mb-2">
                                    <button
                                      className="btn-gray btn-hover w-100"
                                      style={{
                                        padding: '12px',
                                        border: '2px solid #e9ecef',
                                        borderRadius: '8px',
                                        fontSize: '15px',
                                        fontWeight: '500',
                                        transition: 'all 0.3s ease',
                                        backgroundColor: '#fff',
                                      }}
                                      onMouseEnter={(e) => {
                                        e.target.style.borderColor = '#007bff';
                                        e.target.style.boxShadow =
                                          '0 2px 8px rgba(0, 123, 255, 0.15)';
                                        e.target.style.transform =
                                          'translateY(-1px)';
                                      }}
                                      onMouseLeave={(e) => {
                                        e.target.style.borderColor = '#e9ecef';
                                        e.target.style.boxShadow = 'none';
                                        e.target.style.transform =
                                          'translateY(0)';
                                      }}
                                    >
                                      <img
                                        src={googleLogin}
                                        style={{
                                          height: '20px',
                                          paddingRight: '10px',
                                        }}
                                        alt="Google Logo"
                                      />
                                      Login in with Google
                                    </button>
                                  </div>
                                  <div className="mt-4 text-center">
                                    <p className="mb-0">
                                      Don't have an account ?{' '}
                                      <Link
                                        to="/signup"
                                        className="fw-medium text-decoration-underline"
                                      >
                                        {' '}
                                        Register{' '}
                                      </Link>
                                    </p>
                                  </div>
                                </TabPane>
                              </TabContent>
                            </div>
                          </CardBody>
                        </Col>
                        <Col lg={2}></Col>
                      </Row>
                    </div>
                  </Col>
                </Row>
              </Container>
            </section>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default SignIn;
